/**
 * Acréscimo por kg quando o cliente não devolve a sucata (bateria usada).
 * Preço base do produto = COM SUCATA; sem sucata = base + (peso kg × este valor).
 */
export const SCRAP_SURCHARGE_PER_KG = 5.5

/**
 * Verifica se o CEP é da região de Campinas/SP (13xxx).
 * Usado para exibir a opção de devolver sucata na entrega/retirada.
 */
export function isCampinasRegion(zipCode: string): boolean {
  const cleanZip = parseInt(zipCode.replace(/\D/g, ''), 10)
  if (Number.isNaN(cleanZip)) return false
  return cleanZip >= 13000000 && cleanZip <= 13999999
}

/**
 * Calcula o preço efetivo por unidade considerando devolução de sucata.
 * COM sucata (Campinas + willReturnScrap): apenas o preço do produto.
 * SEM sucata: preço do produto + (peso kg × SCRAP_SURCHARGE_PER_KG).
 * Fora de Campinas: sempre aplica acréscimo (sem opção de devolver).
 */
export function getEffectiveUnitPrice(
  unitPrice: number,
  weightKg: number,
  isCampinas: boolean,
  willReturnScrap: boolean
): number {
  const surcharge = (isCampinas && willReturnScrap) ? 0 : (weightKg || 0) * SCRAP_SURCHARGE_PER_KG
  return unitPrice + surcharge
}
